export default __webpack_public_path__ + "static/media/def.d19cdf2b.svg";